import type { TokenizerAndRendererExtension, Tokens } from 'marked'

export const juchatsThinking: TokenizerAndRendererExtension = {
  name: 'juchatsThinking',
  level: 'block',
  start(src: string) {
    return src.match(/<juchats-thinking>/)?.index
  },
  tokenizer(src: string) {
    const rule = /^<juchats-thinking>([\s\S]*?)(?:<\/juchats-thinking>|$)/
    const match = rule.exec(src)
    if (match) {
      const token = {
        type: 'juchatsThinking',
        raw: match[0],
        text: match[1].trim(),
        tokens: [],
      }
      this.lexer.blockTokens(token.text, token.tokens)
      return token
    }
  },
  renderer(token: Tokens.Generic) {
    return ` <div class="language-thinking"> <div class='w-[90px] collapse-btn h-[30px] collapse-thinking rounded-full border-[1px] border-[var(--artifacts-code-border)] flex items-center justify-center cursor-pointer select-none mt-[12px] mb-[26px]'
    onclick='this.classList.toggle("collapse-thinking");'>
    <span class='font-Lexend text-[12px] mr-[9px]'>Thinking</span>
    <svg width="6px" height="3.66667714px" viewBox="0 0 6 3.66667714" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Juchats-Dev-Thinking" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Website-Index-Model-Thinking" transform="translate(-840, -296)" fill="#384A67" fill-rule="nonzero">
                <g id="编组-6" transform="translate(748, 282)">
                    <polygon id="路径" transform="translate(95, 15.8333) scale(1, -1) translate(-95, -15.8333)" points="94.9999906 16.3333134 97.3333417 14 98 14.666663 94.9999906 17.6666771 92 14.666663 92.6666677 14"></polygon>
                </g>
            </g>
        </g>
    </svg>
</div><div class="thinking border-none m-0 bg-[var(--artifacts-code-path-bg)] rounded-[10px] p-[16px] overflow-visible"><div class="thinking-content">${this.parser.parse(token.tokens ?? []).trim()}</div></div></div>`;
  },
}
